import { StaticBaseDao } from '@/dao';
import { Licence } from '@/objects/generated';

export class LicenceDao extends StaticBaseDao {
    public static async GetLicences(FederationID: number): Promise<Licence[]> {
        return this.BaseFetchArray(
            Licence,
            `Licence/GetLicences` + '?' + (FederationID == undefined ? '' : `FederationID=${FederationID}`),
            'GET',
        );
    }
}
